<template>
  <div>
    <v-text-field
      v-model="formData.kv"
      label="KV"
      outlined
      clearable
      dense
      autofocus
      @keydown.enter="generateInfoBL"
    ></v-text-field>

    <h3>Preview</h3>
    <p v-if="state.noData">No Data</p>

    <v-row
      class="fill-height"
      align-content="center"
      justify="center"
      v-if="state.loading"
    >
      <v-col class="text-subtitle-1 text-center" cols="12">
        Loading Data
      </v-col>
      <v-col cols="6">
        <v-progress-linear
          color="deep-purple accent-4"
          indeterminate
          rounded
          height="6"
        ></v-progress-linear>
      </v-col>
    </v-row>

    <main
      class="report"
      v-if="!state.noData && !state.loading && data.vessel"
      id="section-print"
    >
      <div class="header">
        <h1 class="report-title">{{ companyName }} - Masterlis</h1>
        <div class="detil">
          <p class="mb-0 font-italic">
            Kv: <b>{{ data.vessel.kv }}</b>
          </p>
          <p class="mb-0 font-italic">
            Vessel: <b>{{ data.vessel.vessel }}</b>
          </p>
          <p class="mb-0 font-italic">
            Tgl Berangkat: <b>{{ tgl_berangkat }}</b>
          </p>
        </div>
      </div>

      <div class="ports" v-for="port in data.ports" :key="port.port_tujuan">
        <div class="minor-detil">
          <p class="mb-0 font-italic">
            Port Tujuan: <b>{{ port.port_tujuan }}</b>
          </p>
          <!-- <p class="mb-0 font-italic">Total Container: <b>{{ data.vessel.total_container }}</b></p> -->
        </div>

        <div class="port mt-2" v-for="serve in port.serve" :key="serve.id">
          <div>
            <div class="head">
              <p class="tos font-italic">
                Service Cabang: <b>{{ serve.tos }}</b>
              </p>
            </div>
            <table width="100%" class="border-bottom">
              <thead>
                <td class="text-left font-italic">No Container</td>
                <td class="font-italic text-center"></td>
                <td width="40%" class="font-italic">TTB</td>
                <td class="font-italic">Cargo</td>
              </thead>
              <tbody>
                <tr v-for="container in serve.containers" :key="container.id">
                  <td class="vertical-start">
                    <b>{{ container.prioritas_berangkat }}</b>
                    {{ container.no_container }} / {{ container.no_seal }} (KC:
                    {{ container.kc }})
                  </td>
                  <td>
                    <template
                      v-if="
                        container.cargo != 'campuran' &&
                          container.cargo != 'campuran'
                      "
                    >
                      <div>
                        <p
                          class="mb-0"
                          v-for="contDetil in container.container_detil"
                          :key="contDetil.id"
                        >
                          {{ contDetil.ttb.kondisi_detil.kondisi }}
                        </p>
                      </div>
                    </template>
                  </td>
                  <td>
                    <template
                      v-if="
                        container.cargo != 'campuran' &&
                          container.cargo != 'campuran'
                      "
                    >
                      <div>
                        <p
                          class="mb-0"
                          v-for="contDetil2 in container.container_detil"
                          :key="contDetil2.id"
                        >
                          {{ contDetil2.ttb.nottb }} -
                          <span v-if="contDetil2.ttb.penerima_detil">{{
                            contDetil2.ttb.penerima_detil.badan_usaha
                          }}</span>
                          <span v-if="contDetil2.ttb.penerima_detil">{{
                            contDetil2.ttb.penerima_detil.nama
                          }}</span>
                        </p>
                      </div>
                    </template>
                  </td>
                  <td>{{ container.cargo }}</td>
                </tr>
              </tbody>
            </table>
            <p class="total-cont text-right font-italic">
              Total Container: {{ serve.containers.length }}
            </p>
          </div>
        </div>
      </div>
    </main>

    <!-- Print Button -->
    <v-btn
      class="mx-2"
      fab
      dark
      right
      bottom
      fixed
      color="success"
      v-if="!state.noData && !state.loading && data.vessel"
      @click="printDocument"
    >
      Print
    </v-btn>
  </div>
</template>

<script>
import axios from "axios";
import variableMixin from "@/mixins/variableMixin";

export default {
  mixins: [variableMixin],
  data() {
    return {
      state: {
        loading: false,
        noData: false
      },
      formData: {
        kv: ""
      },
      data: {},
      months: [
        "Januari",
        "Februari",
        "Maret",
        "April",
        "Mei",
        "Juni",
        "Juli",
        "Agustus",
        "September",
        "Oktober",
        "November",
        "Desember"
      ],
      days: ["Minggu", "Senin", "Selasa", "Rabu", "Kamis", "Jumat", "Sabtu"]
    };
  },
  watch: {
    "formData.kv"(val) {
      if (val) {
        this.formData.kv = val.toUpperCase();
      }
    }
  },
  computed: {
    today() {
      let date = new Date();
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    },
    tgl_berangkat() {
      let date = new Date(this.data.vessel.tgl_berangkat);
      let day = date.getDay();
      let month = date.getMonth();
      let year = date.getFullYear();

      return `${this.days[day]}, ${date.getDate()} ${
        this.months[month]
      } ${year}`;
    }
  },
  methods: {
    printDocument() {
      window.print();
    },
    async generateInfoBL() {
      this.state.loading = true;

      await axios
        .get(`laporan/masterlis-vessel?kv=${this.formData.kv}`)
        .then(res => {
          if (!res.data.vessel) {
            this.state.noData = true;
          } else {
            this.state.noData = false;
            this.data = res.data;
          }

          this.state.loading = false;
        })
        .catch(err => {
          this.state.loading = false;

          alert(err.response.data.message);
        });
    }
  }
};
</script>

<style lang="css" scoped>
.report {
  background-color: white;
  width: 100%;
  font-family: times;
  padding: 20px;
  color: black;
}

.header {
  border-bottom: 1px solid black;
}

.header .detil {
  width: 70%;
  display: flex;
  justify-content: space-between;
}

.minor-detil {
  width: 40%;
  display: flex;
  justify-content: space-between;
}

table.border-bottom {
  border-bottom: 1px solid black;
}

.vertical-start {
  vertical-align: text-top;
}
</style>
